import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import 'react-tabs/style/react-tabs.css';


import * as PD from '../classes/pdStyle';
import {cloneObject, getParam} from '../utils/utils';
import {formatDate, formatText, truncate} from '../utils/utils';


import dsd from "../classes/clsDSD";

import D3Graphviz from "../components/D3Graphviz";
import ViewDataDictionary from "../components/ViewDataDictionary";
import ViewMetadata from "../components/ViewMetadata";
import ListStructures from "../components/ListStructures";
import ListEnumerations from "../components/ListEnumerations";

import Version from "../components/Version";
import ListVersions from "../components/ListVersions";
import ViewDataDictionaryVersion from "../components/ViewDataDictionaryVersion";

import ViewVersion from "../components/ViewVersion";
import {zipDataDictionary} from "../utils/utilsDataDictionary";

import { assetsDataDictionaryVersion } from "../utils/utilsDataDictionary";

import { Reply } from "react-bootstrap-icons";


import { DesignerLayoutContext } from '../contexts/DesignerLayoutContext';

import Buffering from "../components/Buffering";
import Rendition from '../components/Rendition';


import {getDataDictionary, getDataDictionaryVersion,  addDataDictionary, editDataDictionary} from '../utils/utilsDataDictionary';

import JSZip from "jszip";


class DataDictionary extends React.Component {

    static contextType = DesignerLayoutContext;

    constructor(props) {
        super(props);
        this.state = {
            mode: 'view',
            isLoaded: false,
            loadData:false
        };


        this.data = {};
        this.viz = null;
        this.vizEngine = "dot";

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleMode = this.handleMode.bind(this);
        this.handleButton = this.handleButton.bind(this);
        this.handleVizClick = this.handleVizClick.bind(this);

        this.handleStructureFilters = this.handleStructureFilters.bind(this);
        this.handleEnumerationFilters = this.handleEnumerationFilters.bind(this);

        this.handleExport = this.handleExport.bind(this);


        this.handleAddVersion = this.handleAddVersion.bind(this);
        this.VersionOnActioned = this.VersionOnActioned.bind(this);
        this.loadedVersions = this.loadedVersions.bind(this);
        this.loadedStructures = this.loadedStructures.bind(this);
        this.loadedEnumerations = this.loadedEnumerations.bind(this);

        this.dsd = new dsd();
        this.dsd.StateObject = this;

        this.FallBackNavigation = `/datadictionaries`;


    }

    componentDidMount(){

       this.setup();

    }


    componentDidUpdate(prevProps, prevState){

        // Handle route/props changes
        if (!isEqual(this.props, prevProps)){
            this.setup();
        }

    }
    
    loadDataDictionary(id){

        if (id === undefined || id === null){
            return;
        }

        this.setState({ renderState: 'loading' });

        // Main data dictionary load
        const onLoad = function(DataDictionary) {
            let StateChange = {
                DataDictionary: DataDictionary,
                isLoaded: true,
                renderState: 'loaded'
            };

            StateChange.FormData = DataDictionary;
            StateChange.OfferEdit = false;
            
            if (this.dsd.loggedon){
                if (this.dsd.user.id === DataDictionary.idUser){
                    StateChange.OfferEdit = true;
                }
            }

            this.setState(StateChange, () => {
                this.setLayoutContent();

                // Set up breadcrumb navigation
                for (var i in window.Breadcrumb){
                    if (window.Breadcrumb[i][0] === 'datadictionary'){
                        window.Breadcrumb = window.Breadcrumb.slice(0,i);
                        break;
                    }
                }
                this.Breadcrumb = JSON.parse(JSON.stringify(window.Breadcrumb));
                window.Breadcrumb.push(['data dictionary',`/datadictionary/${id}`]);

                this.FallBackNavigation = `../datadictionaries`;
                this.onUpdateNavigation = this.FallBackNavigation;

            });

        }.bind(this);

        const onFail = function(e) {
            if (e.response){
                if (e.response.status === 403){
                    this.setState({
                        renderState: 'denied',
                        errorMessage: 'Access Denied'
                    });
                } else {
                    this.setState({
                        renderState: 'failed',
                        errorMessage: e.message || 'Failed to load data dictionary'
                    });
                }
            } else {
                this.setState({
                    renderState: 'failed',
                    errorMessage: e.message || 'Failed to load data dictionary'
                });
            }
        }.bind(this);

        getDataDictionary(this.dsd, id, onLoad, onFail);
        
        return;
        
    };

    async loadVersionAssets(id, idVersion){

        if (!id || idVersion == null){
            return;
        }

        this.setState({ renderState: 'loading' });

        const assets = await assetsDataDictionaryVersion(this.dsd, id, idVersion);

        this.setState({
            mdVersionPage: assets["page.md"],
            VersionAssets: assets,
            isLoaded: true,
            renderState: 'loaded'
        });

        return;
        
    };

    setup(){


        let StateChange = {
            id: null,
            isLoaded: false,
            isUpdated: false,
            isFailed: false,
            renderState: 'loading',
            errorMessage: '',

            OfferEdit: false,

            FormData: {},
            Controls: {
            },
            StructureFilters: {
                status:'in use',
                search: ''
            },
            EnumerationFilters: {
                status:'in use'
            },

            DataDictionary: null,
            Structures: null,
            Enumerations: null,

            idVersion: null,
            mdVersionPage: null,

            action: null,

            updateToggle: 0,

            countVersions: null,
            countStructures: null,
            countEnumerations: null,


            vizNodeId: null
        }

        StateChange.mode = getParam('mode', this.props);
        StateChange.idDataDictionary = getParam('id', this.props);

        if (StateChange.mode == null){
            StateChange.mode = 'view';
        }

        // For new mode, set as loaded immediately
        if (StateChange.mode === 'new'){
            StateChange.isLoaded = true;
            StateChange.renderState = 'loaded';
        }

        StateChange.idVersion = getParam('idVersion', this.props);


        this.setState(StateChange, async () => {

           if (this.state.idVersion){
               await this.loadVersionAssets(this.state.idDataDictionary, this.state.idVersion);
               if (this.context.hasLayout){
                   this.context.Layout.setLeftAsDataDictionaryVersions(this.state.idDataDictionary);
               }
               return;
           }

            if (this.state.idDataDictionary){
                this.loadDataDictionary(this.state.idDataDictionary);
            }

       });
        
    }

    handleChange(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        let Controls = this.state.Controls;

        switch (FormFieldName){
            default:
                let FormData = this.state.FormData;
                FormData[FormFieldName] = FormFieldValue;        
                this.setState({"FormData": FormData});
                break;                
        }
        return;

    };
/*
    handleEnumerationFilters(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        let Filters = this.state.EnumerationFilters;
        Filters[FormFieldName] = FormFieldValue;
        this.setState({"EnumerationFilters": Filters, countEnumerations: null});

        return;

    };
*/

    handleStructureFilters(event) {

        if (this.idStructureFilterTimeout) {
            clearTimeout(this.idStructureFilterTimeout);
        }

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox") {
            FormFieldValue = event.target.checked;
        }

        const Filters = {
            ...this.state.StructureFilters,
            [FormFieldName]: FormFieldValue
        };

        const setFilters = () => {
            this.setState((prevState) => {
                if (isEqual(prevState.StructureFilters, Filters)) {
                    return null;
                }

                return {
                    StructureFilters: Filters,
                    countStructures: null
                };
            });
        };

        switch (FormFieldName) {
            case 'search':
                this.idStructureFilterTimeout = setTimeout(setFilters, 500);
                return;
        }

        setFilters();

        return;

    };

    handleEnumerationFilters(event) {

        if (this.idEnumerationFilterTimeout) {
            clearTimeout(this.idEnumerationFilterTimeout);
        }

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox") {
            FormFieldValue = event.target.checked;
        }

        const Filters = {
            ...this.state.EnumerationFilters,
            [FormFieldName]: FormFieldValue
        };

        const setFilters = () => {
            this.setState((prevState) => {
                if (isEqual(prevState.EnumerationFilters, Filters)) {
                    return null;
                }

                return {
                    EnumerationFilters: Filters,
                    countEnumerations: null
                };
            });
        };

        switch (FormFieldName) {
            case 'search':
                this.idEnumerationFilterTimeout = setTimeout(setFilters, 500);
                return;
        }

        setFilters();

        return;

    };




    handleSubmit(event) {

        window.scrollTo(0, 0);

        switch (event.target.name){
            case 'btnCancel':
                switch (this.state.mode){
                    case 'new':
                        this.props.navigation(this.FallBackNavigation);
                        break;
                    case 'edit':
                        this.props.navigation(`/datadictionary/${this.state.idDataDictionary}`);
                        break;
        //            case 'remove':
        //                this.savviconfig.removeFactor(this.data.idProject,this.type,this.data.idFactor);
        //                break;  
                    default:
                        break; 
                };

                break;
            case 'btnSave':
            default:

                this.setState({
                    isUpdated: false,
                    isFailed: false,
                    invalidFields: false
                })

                const onError = function(e){
                    console.error('Error saving data dictionary:', e);
                    this.setState({
                        isFailed: true,
                        errorMessage: e.message || 'Failed to save data dictionary'
                    });
                }.bind(this);
        
                switch (this.state.mode){
                    case 'new':
                        const onAdd = function(id){
                            this.props.navigation(`/datadictionary/${id}`);
                        }.bind(this);
                        
                        addDataDictionary(this.dsd, this.state.FormData, onAdd, onError);
                        break;
                    case 'edit':
                        const onUpdate = function(){
                            this.props.navigation(`/datadictionary/${this.state.idDataDictionary}`);
                        }.bind(this);
                        
                        editDataDictionary(this.dsd, this.state.idDataDictionary, this.state.FormData, onUpdate, onError);
                        break;
        //            case 'remove':
        //                this.savviconfig.removeFactor(this.data.idProject,this.type,this.data.idFactor);
        //                break;  
                    default:
                        break; 
                };
    
        };

        event.preventDefault();
    }

    handleMode(event) {
        this.setState({mode: event.target.value});
        event.preventDefault();
    }


    handleButton(event) {

        let StateChange = {};

        switch (event.target.name){
            case 'btnAddStructure':
                this.props.navigation(`/datadictionary/${this.state.idDataDictionary}/structure?mode=new`,{state:{fallbackpath:this.props.location.pathname}});
                break;
            case 'btnAddEnumeration':
                this.props.navigation(`/datadictionary/${this.state.idDataDictionary}/enumeration?mode=new`,{state:{fallbackpath:this.props.location.pathname}});
                break;    
        }

        this.setState(StateChange);

        event.preventDefault();
    };

    handleAddVersion(event) {

        this.setState({newVersion:true});

    }


    handleVizClick(event) {

        let StateChange = {};

        let idNode = null;
        if ("href" in event.target){
            idNode = event.target.href.baseVal;
        }
        else{
            if ("parentElement" in event.target){
                if ("href" in event.target.parentElement){
                    idNode = event.target.parentElement.href.baseVal;
                }        
            }
        }
        

        StateChange.vizNodeId = idNode;

        this.setState(StateChange);

        event.preventDefault();

    };


    log(){

        if (!this.state.isLoaded){
            return null;
        }

        if (!this.state.DataDictionary){
            return null;
        }

        let arrLog = [];
        for (let pos=0;pos<this.state.DataDictionary.Structures.length;pos++){
            let Structure = this.state.DataDictionary.Structures[pos];
            if (Structure.createdAt){
                let LogEntry = {};
                LogEntry.date = Structure.createdAt;
                LogEntry.action = 'created';
                LogEntry.subjectType = 'Structure';
                LogEntry.Subject = Structure;
                LogEntry.name = Structure.name;
                LogEntry.link = `/structure/${Structure._id}`;
                arrLog = this.insertLog(arrLog, LogEntry);
            }
            if (Structure.Revisions){
                for (let posR=0; posR<Structure.Revisions.length;posR++){
                    let Revision = Structure.Revisions[posR];
                    if (Revision.report){
                        let LogEntry = {};
                        LogEntry.date = Revision.createdAt;
                        LogEntry.action = 'revised';
                        LogEntry.subjectType = 'Structure';
                        LogEntry.Subject = Structure;
                        LogEntry.name = Structure.name;
                        LogEntry.link = `/structue/${Structure._id}`;
                        LogEntry.Revision = Revision
                        LogEntry.description = Revision.description;
                        arrLog = this.insertLog(arrLog, LogEntry);
                    }
                }
            }
        }

        if (!arrLog.length){
            return null;
        }

        return (
            <PD.Table>
                <PD.Thead>
                    <PD.Tr>
                        <PD.Th>on</PD.Th>
                        <PD.Th>what</PD.Th>
                        <PD.Th>name</PD.Th>
                        <PD.Th>change</PD.Th>
                        <PD.Th>description</PD.Th>
                    </PD.Tr>
                </PD.Thead>

                <PD.Tbody>
                    {
                        arrLog.map(
                        (entry, pos) => 
                            {
                                return (
                                    <PD.Tr key={pos}>
                                        <PD.Td>{formatDate(entry.date,'dmy')}</PD.Td>
                                        <PD.Td>{entry.subjectType}</PD.Td>
                                        <PD.Td>
                                            <PD.PdNavLink to={entry.link} >{entry.name}</PD.PdNavLink>
                                        </PD.Td>
                                        <PD.Td>{entry.action}</PD.Td>
                                        <PD.Td>
                                            <PD.MdPresent>{truncate(entry.description, 400)}</PD.MdPresent>
                                        </PD.Td>
                                    </PD.Tr>
                                )
                            }
                        )
                    }
                </PD.Tbody>
            </PD.Table>

        )


    }

    insertLog(array, entry){

        let boolInserted = false;

        let newArray = [];

        for (let pos=0; pos<array.length;pos++){
            if (!boolInserted){
                if (entry.date < array[pos].date){
                    newArray.push(entry);
                    boolInserted = true;
                }
            }
            newArray.push(array[pos]);
        }

        if (!boolInserted){
            newArray.push(entry);
        }

        return newArray;

    }

    versions(){

        if (!this.state.isLoaded){
            return null;
        }

        if (!this.state.DataDictionary){
            return null;
        }

        let newVersion = false;
        let showAdd = false;

        if (this.state.OfferEdit){
            showAdd = true;
        }
        if (this.state.newVersion){
            showAdd = false;
            newVersion = true;
        }

        return (
            <div>
                {showAdd &&
                    <div style={{display:"flex"}}>
                        <PD.Button name='btnAdd' value='add a Named Version' onClick={this.handleAddVersion}/>
                    </div>
                }
                
                {newVersion &&
                    <Version mode='new' idAbout={this.state.idDataDictionary} type='datadictionary' onActioned={this.VersionOnActioned}/>
                }
                <ListVersions key={this.state.updateToggle} OfferEdit={this.state.OfferEdit} filters={{idAbout:this.state.idDataDictionary}} onLoad={this.loadedVersions}/>

            </div>
        )
    }

    VersionOnActioned(){
       this.setState(
        {
            newVersion:false,
            updateToggle: Number(!this.state.updateToggle)
        })
    }

    loadedVersions(count){

        let StateChange = {};

        StateChange.countVersions = 0;
        if (count){
            StateChange.countVersions = count;
        }

        this.setState(StateChange);

    }


    loadedStructures(count){

        let StateChange = {};

        StateChange.countStructures = 0;
        if (count){
            StateChange.countStructures = count;
        }

        this.setState(StateChange);

    }

    loadedEnumerations(count){

        let StateChange = {};

        StateChange.countEnumerations = 0;
        if (count){
            StateChange.countEnumerations = count;
        }

        this.setState(StateChange);

    }


    async handleExport(event){

        this.setState({isExporting: true});
        try {
            let idDataDictionary = this.state.idDataDictionary;
            let idVersion = this.state.idVersion;
            let zipData = null;
            let link = null;

            zipData = await zipDataDictionary(this.dsd, idDataDictionary, idVersion);

            link = document.createElement("a");
            link.href = window.URL.createObjectURL(zipData);
            link.download = `datadictionary_${idDataDictionary}_version_${idVersion}.zip`;
            link.click();
        } finally {
            this.setState({isExporting: false});
        }
    }

    visualise(){
    
        if (!this.state.DataDictionary){
            return <Buffering/>;
        }



        try {

            return(
                <div>
                    <div name="divViz" onClick={this.handleVizClick}>
                        <D3Graphviz dot={this.viz.dot}/>
                    </div>

                </div>
            );
          } catch (error) {
            return <div/>
          }
    };

    setLayoutContent(){

        if (this.context.hasLayout){
            if (this.state.DataDictionary){
                this.context.Layout.setLeftAsDataDictionary(this.state.DataDictionary._id);
            }
        }

        return;

    }


    showError(){


        if (this.state.invalidFields){
            return(
                <>
                    {
                        Object.keys(this.state.invalidFields).map(
                        (field, pos) => 
                            {
                                let error = this.state.invalidFields[field].error;
                                return <p key={pos}>{field}:{error}</p>
                            }
                        )
                    }
                </>
            )
        }

        return "ERROR - Failed to Update";

    }



    render() {

        // Handle loading/error states
        if (this.state.mode === 'view'){
            switch(this.state.renderState){
                case 'loading':
                    return <Buffering />;
                case 'failed':
                    return (
                        <div>
                            <PD.ErrorBox>Error: {this.state.errorMessage}</PD.ErrorBox>
                        </div>
                    );
                case 'denied':
                    return (
                        <div>
                            <PD.ErrorBox>Access Denied</PD.ErrorBox>
                        </div>
                    );
                default:
                    break;
            }
        }

        if (this.state.isUpdated){
            switch (this.state.mode){
                case 'remove':
                    this.props.navigation(this.FallBackNavigation);
                    return null;
                default:
                    break;
            };
        };


        if (this.state.idVersion){
            return(
                <div>
                    <PD.Button onClick={ () => this.props.navigation(`/datadictionary/${this.state.idDataDictionary}`) } value="back"><Reply/></PD.Button>
                    <PD.Button onClick={this.handleExport} name="btnExport" value={this.state.isExporting ? "" : "export"}>
                        {this.state.isExporting && <Buffering/>}
                    </PD.Button>
                    <ViewVersion mdPage={this.state.mdVersionPage} assets={this.state.VersionAssets} idVersion={this.state.idVersion}/>
                </div>
            )
        }



        if (this.state.isLoaded || this.state.mode === 'new') {

            switch (this.state.mode){
                case 'new':
                case 'edit':

                    return (
                    <div>

                        <PD.Heading>{this.state.mode} Data Dictionary</PD.Heading>
    
                        {this.state.isFailed &&
                            <PD.ErrorBox>{this.showError()}</PD.ErrorBox>
                        }
    
                        <form> 
                            <PD.Input label="Name" width="60" name="name" value={this.state.FormData.name} onChange={this.handleChange}/>

                            <PD.Editor label='Description' name="description" value={this.state.FormData.description} onChange={this.handleChange}/>

                            <PD.Input label="Namespace" width="30" name="namespace" value={this.state.FormData.namespace} onChange={this.handleChange}/>
                            <PD.Input label="Default Prefix" width="10" name="prefix" value={this.state.FormData.prefix} onChange={this.handleChange}/>

                            <PD.Editor label='Proposals' name="proposals" value={this.state.FormData.proposals} onChange={this.handleChange}/>

                            <PD.Select label="Status" name='status'  onChange={this.handleChange} value={this.state.FormData.status}>
                                {
                                    this.dsd.config.ComponentStatuses.map(
                                        (status, posStatus) => 
                                            {
                                                return(
                                                    <option key={posStatus} value={status}>{status}</option>
                                                )
                                            }
                                    )
                                }
                            </PD.Select>

                            <PD.Button type="submit" onClick={this.handleSubmit} name="btnSave"value="Save" />    
                            <PD.Button type="warning" onClick={this.handleSubmit} name="btnCancel" value="Cancel" />    
                        </form>
    
                    </div>    
                    );
                case 'remove':
                    return (
                        <div>
                            <PD.Heading>{this.state.mode} Data Dictionary</PD.Heading>

                            {this.state.isFailed &&
                                <PD.ErrorBox>ERROR - Failed to Update</PD.ErrorBox>
                            }

                            <PD.Button onClick={this.handleSubmit} type="warning" value="confirm remove?" />
                            <ViewDataDictionary json={this.state.DataDictionary}/>
                        </div>
                    )
                case 'view':
                default:

                    if (!this.state.DataDictionary){
                        return <div/>
                    }
                    

                    return (
                        <div>
                            <div>
                                <PD.Breadcrumb crumbs={this.Breadcrumb}/>
                                <PD.Heading>Data Dictionary:{this.state.DataDictionary.name}</PD.Heading>
                            </div>

                            {this.state.OfferEdit &&
                                <span style={{paddingRight:10}}>
                                        <PD.Button onClick={this.handleMode} type="submit" value="edit" />                        
                                </span>
                            }

                            <ViewDataDictionary DataDictionary={this.state.DataDictionary}/>

                            <br/>

                            <PD.Tabs>

                                <div label={<span>Structures({this.state.countStructures === null ? <Buffering/> : this.state.countStructures})</span>}  data-forcerender="true">
                                    <div style={{display:"flex"}}>
                                        {this.state.OfferEdit &&                           
                                            <PD.Button name='btnAddStructure' value='add a new Structure' onClick={this.handleButton}/>
                                        }
                                        <fieldset style={{display:"flex"}}>
                                            <legend>filters</legend>
                                            <PD.Select label='status' name='status'  onChange={this.handleStructureFilters} value={this.state.StructureFilters.status}>
                                                {
                                                    this.dsd.config.StructureStatuses.map(
                                                        (status, posStatus) => 
                                                            {
                                                                return(
                                                                    <option key={posStatus} value={status}>{status}</option>
                                                                )
                                                            }
                                                    )
                                                }
                                            </PD.Select>
                                            <PD.Input label="Search" width="15" name="search" value={this.state.StructureFilters.search} onChange={this.handleStructureFilters}/>
                                            
    
                                        </fieldset>
                                    </div>
                                    <ListStructures filters={{idDataDictionary:this.state.idDataDictionary, ...this.state.StructureFilters}}  onLoad={this.loadedStructures} />
                                </div>

                                <div label={<span>Enumerations({this.state.countEnumerations === null ? <Buffering/> : this.state.countEnumerations})</span>}  data-forcerender="true">
                                    <div style={{display:"flex"}}>
                                        {this.state.OfferEdit &&                           
                                            <PD.Button name='btnAddEnumeration' value='add a new Enumeration' onClick={this.handleButton}/>
                                        }
                                        <fieldset style={{display:"flex"}}>
                                            <legend>filters</legend>
                                            <PD.Select label='status' name='status'  onChange={this.handleEnumerationFilters} value={this.state.EnumerationFilters.status}>
                                                {
                                                    this.dsd.config.EnumerationStatuses.map(
                                                        (status, posStatus) => 
                                                            {
                                                                return(
                                                                    <option key={posStatus} value={status}>{status}</option>
                                                                )
                                                            }
                                                    )
                                                }
                                            </PD.Select>
                                            <PD.Input label="Search" width="15" name="search" value={this.state.EnumerationFilters.search} onChange={this.handleEnumerationFilters}/>

    
                                        </fieldset>
                                    </div>
                                    <ListEnumerations filters={{idDataDictionary:this.state.idDataDictionary,...this.state.EnumerationFilters}}  onLoad={this.loadedEnumerations} />
                                </div>

                                <div label='Log'>
                                    {this.log()}
                                </div>

                                <div label={<span>Versions({this.state.countVersions === null ? <Buffering/> : this.state.countVersions})</span>}  data-forcerender="true">
                                    {this.versions()}
                                </div>


                                <div label='Developer'>
                                    <Rendition
                                        endpoint="/datadictionaries"
                                        id={this.state.idDataDictionary}
                                    />
                                </div>


                                <div label='Metadata'>
                                    <ViewMetadata Data={this.state.DataDictionary} />
                                </div>


                            </PD.Tabs>


                        </div>
                    )
            };
        };

        return <div />;
    };
};

// Wrap and export
export default function DataDictionary_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <DataDictionary {...props} navigation={navigation} location={location} params={params} />;
  }
